import { RemoteHandleActivitiesAnalyticalPerGroup } from 'data/usecases';
import { HandleActivitiesAnalyticalPerGroupUseCaseInterface } from 'domain/usecases';
import { makeApiUrlActivitiesAnalyticalPerGroup } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeHandleActivitiesAnalyticalPerGroup =
  (): HandleActivitiesAnalyticalPerGroupUseCaseInterface =>
    new RemoteHandleActivitiesAnalyticalPerGroup(
      makeApiUrlActivitiesAnalyticalPerGroup(),
      makeAxiosHttpClient(),
    );
